export const DOVE_IT_INBOUND_PHONE_NUMBER = '+390287178289';
export const DOVE_IT_INBOUND_MOBILE_PHONE_NUMBER = '+393272074613';
